module.exports = __webpack_public_path__ + "static/media/Imagen_11.6b12668e.jpg";